import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'

// Reusable password field with a show/hide eye toggle, wrapping react-bootstrap's Form.Control.
export default function PasswordInput({ className, ...rest }) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="password-input-field">
      <Form.Control
        {...rest}
        type={visible ? 'text' : 'password'}
        className={[className, 'password-input-control'].filter(Boolean).join(' ')}
      />
      <Button
        type="button"
        variant="link"
        className="password-input-toggle"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
      >
        <i className={visible ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'} aria-hidden="true"></i>
      </Button>
    </div>
  )
}
